import { ProfileMultiSelectInput, ProfileSelectInput } from "@/src/components";
import { Card, CardContent, CardHeader, Grid } from "@mui/material"
import { AutocompleteInput, BooleanInput, DateInput, DateTimeInput, NumberInput, ReferenceInput, required, SaveButton, SelectInput, TextInput, Toolbar } from "react-admin"


const keepText = (value: string) => (value);
export const SectionUserEditProfileInfo = () => {
    return (
        <Card variant="outlined">
            <CardHeader title={"Profile info"} />
            <CardContent>

                {/* <Box flex={1}> */}
                {/* <Typography variant="h6" gutterBottom>Profile info</Typography> */}

                <TextInput variant="outlined" source="profile.nickname" label="Nickname"
                    helperText={false} fullWidth />
                <DateInput variant="outlined" source="profile.dob" label="DOB"
                    helperText={false} fullWidth
                    validate={[required()]}
                />
                <TextInput variant="outlined" source="profile.age" label="Age"
                    helperText={false} fullWidth
                    disabled />
                <ProfileSelectInput source="profile.gender" label="Gender" helperText={false}
                    fullWidth
                    validate={[required()]}
                />
                <ProfileSelectInput source="profile.datingAs" label="Dating as"
                    helperText={false} fullWidth
                    validate={[required()]}
                />
                <Grid container spacing={1}>
                    <Grid size={6}>
                        <BooleanInput source="profile.isSponsor" label="Is sponsor"
                            helperText={false} />
                    </Grid>
                    <Grid size={6}>
                        <BooleanInput source="profile.isSponsorLock" label="Is sponsor lock"
                            helperText={false} />
                    </Grid>
                </Grid>
                <ProfileSelectInput source="profile.sexOrientation" label="Sex orientation"
                    helperText={false} fullWidth />
                <TextInput variant="outlined" source="profile.slogan" label="Slogan" multiline
                    rows={2} helperText={false} fullWidth
                    parse={keepText}
                />
                <TextInput variant="outlined" source="profile.about" label="About" multiline
                    rows={4} helperText={false} fullWidth
                    parse={keepText}
                />
                <ReferenceInput variant="outlined" label="City" source="profile.city"
                    helperText={false}
                    reference="city" fullWidth>
                    <AutocompleteInput optionText="name" validate={[required()]}
                        filterToQuery={(txt: string) => ({ name: txt })}
                    />
                </ReferenceInput>
                <ProfileMultiSelectInput source='profile.languages' label="Languages"
                    fullWidth />
                <ProfileSelectInput source="profile.purpose" label="Purpose"
                    helperText={false} fullWidth validate={[required()]} />
                <ProfileSelectInput source="profile.familyStatus" label="Family status"
                    helperText={false} fullWidth />
                <ProfileSelectInput source="profile.children" label="Children"
                    helperText={false} fullWidth />
                <ProfileSelectInput source="profile.education" label="Education"
                    helperText={false} fullWidth />
                <ProfileSelectInput source="profile.occupation" label="Occupation"
                    helperText={false} fullWidth />
                <ProfileSelectInput source="profile.availableTime" label="Available time"
                    helperText={false} fullWidth />
                <ProfileSelectInput source="profile.incomeLevel" label="Income level"
                    helperText={false} fullWidth />
                <ProfileMultiSelectInput source='profile.hobbies' label="Hobbies"
                    helperText={false} fullWidth />
                <ProfileSelectInput source="profile.bdsmRelations" label="BDSM relations"
                    helperText={false} fullWidth />
                <ProfileSelectInput source="profile.sponsorType" label="Sponsor type"
                    helperText={false} fullWidth />
                <ProfileSelectInput source="profile.sponsorExpectations"
                    label="Sponsor expectations"
                    helperText={false} fullWidth />
                <NumberInput variant="outlined" source="profile.searchAge.min"
                    label="Search age min" helperText={false} fullWidth
                    validate={[required()]} />
                <NumberInput variant="outlined" source="profile.searchAge.max"
                    label="Search age max" helperText={false} fullWidth
                    validate={[required()]} />
                <ProfileMultiSelectInput source='profile.interestedIn' label="Interested in"
                    fullWidth />
                <ProfileSelectInput source="profile.smoking" label="Smoking" helperText={false}
                    fullWidth />
                <ProfileSelectInput source="profile.drinking" label="Drinking"
                    helperText={false} fullWidth />
                <ProfileSelectInput source="profile.narcotics" label="Narcotics"
                    helperText={false} fullWidth />
                <ProfileSelectInput source="profile.origin" label="Origin" helperText={false}
                    fullWidth />
                <ProfileSelectInput source="profile.religion" label="Religion"
                    helperText={false} fullWidth />
                <ProfileSelectInput source="profile.ethnicity" label="Ethnicity"
                    helperText={false} fullWidth />
                <ProfileSelectInput source="profile.bodyType" label="Body type"
                    helperText={false} fullWidth />
                <TextInput variant="outlined" source="profile.height" label="Height"
                    type={"number"} helperText={false} fullWidth />
                <TextInput variant="outlined" source="profile.weight" label="Weight"
                    type={"number"} helperText={false} fullWidth />
                <ProfileSelectInput source="profile.hair" label="Hair" helperText={false}
                    fullWidth />
                <ProfileSelectInput source="profile.eyes" label="Eyes" helperText={false}
                    fullWidth />
                <ReferenceInput variant="outlined" label="Mood"
                    source="profile.mood" helperText={false}
                    reference="mood" fullWidth>
                    <SelectInput optionText="id" />
                </ReferenceInput>
                {/* <ProfileSelectInput source="profile.moods" label="Mood" helperText={false}
                        
                                    fullWidth /> */}
                <DateTimeInput variant="outlined" source="profile.moodExpire"
                    label="Edit MoodExpire Time" helperText={false} fullWidth />
                {/* </Box> */}
            </CardContent>
            <Toolbar
            //{...sanitizeToolbarProps(formProps)}
            >
                <SaveButton label="Save" />
            </Toolbar>
        </Card>
    )
}